import { HttpApiError } from '@backmarket/http-api'

export function getHttpErrorStatusCode(err: unknown): number {
  if (err instanceof HttpApiError) {
    return err.status
  }

  if (typeof err === 'object' && err !== null && 'status' in err) {
    return (err as { status: number }).status
  }

  return 0
}

export function getErrorType(statusCode: number): string {
  if (statusCode === 0) {
    return 'network'
  }

  if (statusCode >= 500) {
    return 'api_5xx'
  }

  return 'api_4xx'
}
